import React,{useState} from 'react';

/**
 * The File stores parameters for use outside of the reach of componenets.
 * For example: in styled componentes where the style relyed outside of the coponent definition
 */

 export   const themeParams = {
        // mediaXSUp: '@media (max-width:960px)'
        mediaSMUp: '@media (min-width: 600px)', //sm
        mediaMDUp: '@media (min-width: 900px)', //md
        mediaLGUp: '@media (min-width: 1200px)', //lg
        mediaXLUP: '@media (min-width: 1536px)'  //xl
    }


